<template>
    <div class="time-table container">
        <content-header title="Расписание"/>
        <div class="time-table-section">
            <img src="../assets/images/timetable-300x300.png" alt="timetable">
            <div class="time-table-info">
                <div class="info-title">
                    <p><strong>Уважаемые пациенты!</strong><br>
                        Уточняйте информацию о работе врача по телефонам:</p>
                </div>
                <div class="info-contact">
                    <div>
                        <p style="text-align: left;">Регистратура ОМС: </p>
                        <a class="more-detail" href="tel:+74956208106">8 ( 495 ) 620-81-06</a>
                        <p style="text-align: left;">Регистратура ДМС: </p>
                        <a class="more-detail" href="tel:+74956208105">8 ( 495 ) 620-81-05</a>
                    </div>
                    <div>
                        <p style="text-align: left;">Платные мед.услуги: </p>
                        <a class="more-detail" href="tel:+74956208107">8 ( 495 ) 620-81-07</a>
                        <p style="text-align: left;">Стоматология: </p>
                        <a class="more-detail" href="tel:+74992483106">8 ( 499 ) 248-31-06</a>
                    </div>
                </div>


            </div>
        </div>
        <div class="content-title">
            {{ dateSince.monday }} - {{ dateSince.sunday }} {{ dateSince.year }}
        </div>

        <div class="timetable-tables">
            <time-table-tab :item="item" v-for="(item, index) in getFormattedData" :key="index"/>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../components/layout/ContentHeader";
import TableDefault from "../components/TableDefault";
import {mapActions, mapGetters} from "vuex";
import TimeTableTab from "../components/TimeTableTab";

export default {
    name: "time-table",
    components: {
        ContentHeader,
        TableDefault,
        TimeTableTab
    },
    data() {
        return {
            showTable: false,
            search: '',
            tableId: null
        }
    },
    computed: {
        ...mapGetters(["schedules", "schedulesTable"]),
        getFormattedData() {
            let data = [];
            const monthNames = ["января", "февраля", "марта", "апреля", "мая", "июня",
                "июля", " августа", "сентября", "октября", "ноября", "декабря"
            ];
            for (let item of this.schedules) {
                const monDay = item.week_days && item.week_days.monday.slice(0, 2);
                const sunDay = item.week_days && item.week_days.sunday.slice(0, 2);
                const month = item.week_days && monthNames[new Date(`${item.week_days.monday} ${new Date().getFullYear()}`).getMonth()];
                const lastMonth = item.week_days && monthNames[new Date(`${item.week_days.sunday} ${new Date().getFullYear()}`).getMonth()];
                let formatted = {
                    id: item.id,
                    date: `c ${monDay} ${month} - по ${sunDay} ${lastMonth} ${new Date().getFullYear()}`
                };
                data.push(formatted)
            }
            return data

        },
        dateSince() {
            const monthNames = ["января", "февраля", "марта", "апреля", "мая", "июня",
                "июля", " августа", "сентября", "октября", "ноября", "декабря"
            ];
            const mondayDate = new Date(`${this.schedules[0] && this.schedules[0].week_days.monday} ${new Date().getFullYear()}`)
            const sundayDate = new Date(`${this.schedules[this.schedules.length - 1] && this.schedules[this.schedules.length - 1].week_days.sunday} ${new Date().getFullYear()}`)
            return {
                monday: `${mondayDate.getDate()} ${monthNames[mondayDate.getMonth()]}`,
                sunday: `${sundayDate.getDate()} ${monthNames[sundayDate.getMonth()]}`,
                year: new Date().getFullYear()
            };
        }

    },
    methods: {
        ...mapActions(["fetchSchedulesTable", "fetchSchedules"]),
        filterSchedule() {
            setTimeout(() => {
                this.fetchSchedulesTable({search: this.search, id: this.tableId})
            }, 500)
        },
        showTableAction(id) {
            this.showTable = !this.showTable;
            this.tableId = id;
            this.fetchSchedulesTable({search: this.search, id: this.tableId})
        }
    },
    mounted() {
        this.fetchSchedules();
    }
}
</script>

<style lang="scss" scoped>
.time-table-section {
    display: flex;
    justify-content: space-between;
    margin: 40px 0;

    @media screen and (max-width: 768px) {
        flex-direction: column;
    }

    img {
        width: 150px;
        height: 150px;
    }

    .time-table-info {
        margin-left: 20px;
        max-width: 400px;
        @media screen and (max-width: 768px) {
            margin: 20px 0;
        }
    }

    .info-title {
        text-align: left;
        padding-bottom: 20px;
    }

    .info-contact {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        div {
            text-align: left;
        }

        p {
            color: #666;
        }
    }
}

.content-title {
    color: #000;
    margin: 20px 0;
}

.timetable-tables {
    .table-state {
        background: #006688;
        padding: 10px 12px;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        cursor: pointer;

        @media screen and (max-width: 510px) {
            font-size: 11px;
        }
    }

    .plus, .minus {
        filter: brightness(3);
    }
}

.search-table {

    .search-input {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 20px 0;

        span {
            font-size: 13px;
            margin-right: 10px;
            margin-top: 4px;
        }

        input {
            background-color: #fff;
            padding: 5px;
            border: 1px solid;
            color: #000;
        }
    }
}
</style>